import { h } from 'preact';

export function IconCaret({ width = 10, height = 6 }) {
  return (
    <svg
      aria-hidden="true"
      focusable="false"
      role="presentation"
      viewBox="0 0 10 6"
      width={width}
      height={height}
      class="icon-caret"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z"
        fill="currentColor"
      />
    </svg>
  );
}
